export default __webpack_public_path__ + "static/media/Thumb_Facial_Hair_04.f0e26798.png";